import { render, staticRenderFns } from "./InactiveAlert.vue?vue&type=template&id=0178e702&"
import script from "./InactiveAlert.vue?vue&type=script&lang=js&"
export * from "./InactiveAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports